// extracted by mini-css-extract-plugin
export var gif = "_cj-0";